import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { firstValueFrom } from "rxjs";
import { UserService } from "./user.service";

export class CreateRefreshTokenRequestCommandResult {
  public requestId: string;
  public codeChallenge: string;
}

export enum AccessTokenSource {
  FotoWeb = 0
}

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private API_ENDPOINT = `${environment.apiBaseURL}/auth`;

  constructor(private http: HttpClient, private userService: UserService) {
  }

  async getAccessToken(source: AccessTokenSource): Promise<string> {

    const organizerId = this.userService.OrganizerId;

    return firstValueFrom(this.http.get<string>(`${this.API_ENDPOINT}/access-token`, 
      { params: { source, organizerId }}));
  }

  async getOAuthLink(source: AccessTokenSource, successRedirect: string, 
    failureRedirect: string): Promise<string> {

    const organizerId = this.userService.OrganizerId;

    return firstValueFrom(this.http.get<string>(`${this.API_ENDPOINT}/oauth`, 
      { params: { source, successRedirect, failureRedirect, organizerId }}));
  }
}